import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';

const unitRenderer = (params) => {
  const { value } = params;
  if (params?.data?.isBottomRow) {
    const pinnedValue = parseFloat(params?.value);
    if (pinnedValue < 0) {
      return (
        <b>
          <span
            style={{ color: '#eb0000', textAlign: 'right', display: 'inline' }}
          >
            (
            {` ${Math.abs(parseFloat(pinnedValue)).toLocaleString('en-US', {
              minimumFractionDigits: 4,
              maximumFractionDigits: 4,
            })}`}
            )
          </span>
        </b>
      );
    }
    if (pinnedValue) {
      return (
        <div style={{ textAlign: 'right' }}>
          <b>
            {` ${parseFloat(pinnedValue)?.toLocaleString('en-US', {
              minimumFractionDigits: 4,
              maximumFractionDigits: 4,
            })}`}
          </b>
        </div>
      );
    }
    return (
      <div style={{ textAlign: 'right' }}>
        <b>{' 0.0000'}</b>
      </div>
    );
  }
  if (value < 0) {
    return (
      <span style={{ color: '#eb0000', textAlign: 'right', display: 'inline' }}>
        {` ( ${Math.abs(parseFloat(value)).toLocaleString('en-US', {
          minimumFractionDigits: 4,
          maximumFractionDigits: 4,
        })}
       )`}
      </span>
    );
  }
  if (value) {
    return (
      <div style={{ textAlign: 'right' }}>{` ${parseFloat(
        value
      )?.toLocaleString('en-US', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      })}`}</div>
    );
  }
  return <div style={{ textAlign: 'right' }}>{' 0.0000'}</div>;
};

// For the proper sorting of quarter columns
const comparatorQtr = (a, b) => {
  const splittedQtrA = a?.split('Q');
  const splittedQtrB = b?.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};
function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}
export const ManufactureTableHead = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    sort: 'asc',
    minWidth: Styles.Width_320,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const SearchResult = [
  {
    headerName: 'QTR',
    field: 'qtr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    // maxWidth: 140,
    minWidth: Styles.Width_100,
    comparator: comparatorQtr,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    suppressMenu: false,
    sortable: true,
    sort :'asc' ,
    // maxWidth: 170,
    minWidth: Styles.Width_180,
    cellRenderer: 'TextBoxRender',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    cellClass: 'frr-ellipsis-text',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug name',
    field: 'drugName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_400,
    cellClass: 'frr-ellipsis-text',
    columnSpan: 4,
    cellRenderer: 'TextBoxRender',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'left' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Units',
    field: 'units',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: 150,
    cellRenderer: unitRenderer,
    comparator: amountComparator,
    alignment: 'right',
    excelAlignment: 'right',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isTextColorRed: true,
  },
];
